import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import ButtonBase from '@material-ui/core/ButtonBase'
import Typography from '@material-ui/core/Typography'
import AddIcon from '@material-ui/icons/AddOutlined'
import ScheduleIcon from '@material-ui/icons/ScheduleOutlined'
import DescriptionIcon from '@material-ui/icons/DescriptionOutlined'
import PinIcon from '@material-ui/icons/RoomOutlined'

import { BaseContext } from '../theme.context'
import { FORM_SELECT_FORM } from '../../actions'
import { store } from '../../store'

export class DashboardContainer extends Component {
  static contextType = BaseContext

  componentDidMount() {
    this.context.onChangeColor('#FFF')
    this.context.onChangeleftButton(false)
  }

  render = () => {
    const {
      history,
      classes,
    } = this.props

    return (
      <Container
        fixed
        className={classes.fullHeight}
      >
        <Grid
          container
          justify='center'
          className={classes.fullHeight}
        >
          <Grid
            item
            xs={12}
            className={classes.fullHeight}
          >
            <Grid
              container
              justify='center'
              alignItems='center'
              direction='column'
              className={classes.fullHeight}
            >
              <Grid
                container
                justify='center'
                alignItems='center'
              >
                <Grid item xs={12} md={4}>
                  <ButtonBase
                    focusRipple
                    className={classes.buttonCard}
                    onClick={() => {
                      store.dispatch(FORM_SELECT_FORM(null))
                      history.push('/dashboard/forms/new')
                    }}
                  >
                    <div className={classes.iconContent}>
                      <AddIcon className={classes.icons} />
                    </div>
                    <div className={classes.textContent}>
                      <Typography>
                        {'Iniciar un formulario'}
                      </Typography>
                    </div>
                  </ButtonBase>
                </Grid>
              </Grid>
              <Grid
                container
                justify='center'
                alignItems='center'
              >
                <Grid item xs={12} md={4}>
                  <ButtonBase
                    focusRipple
                    className={classes.buttonCard}
                    onClick={() => history.push('/dashboard/forms/finalized')}
                  >
                    <div className={classes.iconContent}>
                      <DescriptionIcon className={classes.icons} />
                    </div>
                    <div className={classes.textContent}>
                      <Typography>
                        {'Formularios finalizados'}
                      </Typography>
                    </div>
                  </ButtonBase>
                </Grid>
              </Grid>
              <Grid
                container
                justify='center'
                alignItems='center'
              >
                <Grid item xs={12} md={4}>
                  <ButtonBase
                    focusRipple
                    className={classes.buttonCard}
                    onClick={() => history.push('/dashboard/forms/pending')}
                  >
                    <div className={classes.iconContent}>
                      <ScheduleIcon className={classes.icons} />
                    </div>
                    <div className={classes.textContent}>
                      <Typography>
                        {'Formularios pendientes'}
                      </Typography>
                    </div>
                  </ButtonBase>
                </Grid>
              </Grid>
              <Grid
                container
                justify='center'
                alignItems='center'
              >
                <Grid item xs={12} md={4}>
                  <ButtonBase
                    focusRipple
                    className={classes.buttonCard}
                    onClick={() => history.push('/dashboard/points')}
                  >
                    <div className={classes.iconContent}>
                      <PinIcon className={classes.icons} />
                    </div>
                    <div className={classes.textContent}>
                      <Typography>
                        {'Mi Cartera'}
                      </Typography>
                    </div>
                  </ButtonBase>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    )
  }
}

const useStyles = theme => ({
  buttonCard: {
    width: '100%',
    position: 'relative',
    height: 100,
    borderRadius: 8,
    border: '1px solid #e8eaed',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)'
    },
    backgroundColor: '#FFF',
    marginBottom: 20,
  },
  iconContent: { flex: 1 },
  textContent: {
    flex: 3,
    textAlign: 'left',
    '& p': {
      fontSize: '1.2rem',
    },
  },
  icons: {
    color: theme.palette.secondary.main,
    width: '1.2em',
    height: '1.2em',
  },
  fullHeight: { height: '100%' },
})

export default withStyles(useStyles)(DashboardContainer)
